import React, { Fragment } from "react";
import {
  makeStyles,
  Grid,
  FormHelperText,
  TextField,
  Typography,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { Controller, useFormContext } from "react-hook-form";

import { estados } from "../../constants/constants";

const useStyles = makeStyles({
  card: {
    minWidth: "30vw",
    width: "100%",
  },
  title: {
    marginTop: "5px",
    marginRight: "20px",
  },
  pos: {
    marginBottom: 12,
  },
  input: {
    width: "100%",
  },
  item: {
    width: "100%",
  },
  container: {
    padding: "10px",
  },
  cardContent: {
    marginTop: "20px",
    marginBottom: "20px",
  },
});

const FormEditDireccion = ({ direccion }) => {
  const classes = useStyles();
  const { errors, register } = useFormContext();
  const estado = estados.filter((item) => item.value === direccion.estado);
  return (
    <Fragment>
      <Typography className={classes.title} variant="h5" component="h2">
        Dirección
      </Typography>
      <Grid container spacing={2} className={classes.container}>
        <Grid item xs={12} sm={12} md={12} className={classes.item}>
          {/* <CardContent className={classes.cardContent}> */}
          <TextField
            autoComplete="off"
            className={classes.input}
            label="País"
            name="pais"
            disabled
            variant="outlined"
            inputRef={register({
              required: true,
            })}
            value="México"
          />
          {/* </CardContent> */}
        </Grid>
        <Grid item xs={12} sm={12} md={12} className={classes.item}>
          {/* <CardContent className={classes.cardContent}> */}

          <TextField
            type="number"
            autoComplete="off"
            className={classes.input}
            error={!!errors.cp}
            label="Código Postal"
            name="cp"
            variant="outlined"
            defaultValue={direccion.cp}
            inputRef={register({
              required: true,
            })}
          />
          {errors.cp && (
            <FormHelperText error>Este campo es requerido</FormHelperText>
          )}
          {/* </CardContent> */}
        </Grid>
        <Grid item xs={12} sm={12} md={12} className={classes.item}>
          <TextField
            autoComplete="off"
            className={classes.input}
            error={!!errors.calle}
            inputRef={register({
              required: true,
            })}
            label="Calle"
            name="calle"
            variant="outlined"
            defaultValue={direccion.calle}
          />
          {errors.calle && (
            <FormHelperText error>Este campo es requerido</FormHelperText>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={12} className={classes.item}>
          <TextField
            defaultValue={direccion.numero}
            autoComplete="off"
            type="number"
            className={classes.input}
            error={!!errors.numero}
            inputRef={register({
              required: true,
            })}
            label="Número Ext."
            name="numero"
            variant="outlined"
          />
          {errors.numero && (
            <FormHelperText error>Este campo es requerido</FormHelperText>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={12} className={classes.item}>
          <TextField
            autoComplete="off"
            className={classes.input}
            error={!!errors.colonia}
            inputRef={register({
              required: true,
            })}
            label="Colonia"
            name="colonia"
            variant="outlined"
            defaultValue={direccion.colonia}
          />
          {errors.colonia && (
            <FormHelperText error>Este campo es requerido</FormHelperText>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={12} className={classes.item}>
          <TextField
            autoComplete="off"
            className={classes.input}
            error={!!errors.delegacion}
            inputRef={register({
              required: true,
            })}
            label="Delegación"
            name="delegacion"
            variant="outlined"
            defaultValue={direccion.delegacion}
          />
          {errors.delegacion && (
            <FormHelperText error>Este campo es requerido</FormHelperText>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Controller
            name="estado"
            defaultValue={estado[0]}
            rules={{
              required: true,
            }}
            onChange={(data) => {
              return data[1] ? data[1] : "";
            }}
            as={
              <Autocomplete
                id="select-estado-remitente"
                options={estados}
                getOptionLabel={(option) => (option ? option.label : "")}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    autoComplete="off"
                    error={!!errors.estado}
                    fullWidth
                    label="Estado"
                    variant="outlined"
                  />
                )}
              />
            }
          />
          {errors.estado && (
            <FormHelperText error>Este campo es requerido</FormHelperText>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={12} className={classes.item}>
          <TextField
            autoComplete="off"
            className={classes.input}
            error={!!errors.referencia}
            inputRef={register({
              required: true,
            })}
            label="Referencia"
            name="referencia"
            variant="outlined"
            defaultValue={direccion.referencia}
          />
          {errors.referencia && (
            <FormHelperText error>Este campo es requerido</FormHelperText>
          )}
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default FormEditDireccion;
